import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from "rxjs";
import { GadgetApiService, GadgetsService } from '@signature-it/ngx-generic/services';
import { GadgetFilterDTO } from '@signature-it/ngx-generic/models';
import { GenericConfig } from '@signature-it/ngx-generic/config';

declare let _: any;

@Component({
    selector: 'select-gadget',
    templateUrl: './select.gadget.html',
    styleUrls: ['./select.gadget.scss'],
    standalone: false
})
export class SelectGadget implements OnInit{

    @Input() type;
    @Input() filterName;
    filters: Array<GadgetFilterDTO>;
    gadgetFilterSubscription: Subscription;
    options;
    optionSelect;

    constructor(protected gadgetApiSvc: GadgetApiService,
                protected gadgetsSvc: GadgetsService) {}

    ngOnInit() {
        this.filterName = this.filterName || 'Select';
        this.type = this.type || GenericConfig.selectGadget;
        this.gadgetFilterSubscription = this.gadgetsSvc.gadgetFilter.subscribe(filters => {
            this.filters = filters;
        });
        this.gadgetFilterSubscription.unsubscribe();
        this.getData();
    }

    getData() {
        this.gadgetApiSvc.getOptionSelect(this.type)
            .subscribe(
                res => {
                    if (res) {
                        this.options = res;
                        this.optionSelect = this.options[0];
                        this.setDataFilter('start', this.optionSelect.value);
                        this.setDataFilter('end', 'yesterday');
                        this.setDataFilter('prev_start', this.optionSelect.additional_value);
                        this.setDataFilter('prev_end', this.optionSelect.value);
                        this.upadteFilter();
                    }
                }
            )
    }

    setDataFilter(key, val) {
        var currentFilter =  _.find(this.filters, (filter: any) => filter.name === this.filterName && filter.key === key);
        currentFilter['value'] = val;

    }

    upadteFilter(){
        this.gadgetsSvc.gadgetFilter.next(this.filters);
    }

    onOptionSelected(value){
        this.setDataFilter('start', value['value']['value']);
        this.setDataFilter('end', 'yesterday');
        this.setDataFilter('prev_start', value['value'].additional_value);
        this.setDataFilter('prev_end', value['value']['value']);
        this.upadteFilter();
    }
}
